import { jsx as i } from "react/jsx-runtime";
import { useContext as a } from "react";
import { cn as m } from "./designsystem-ui-react47.js";
import { CardContext as p } from "./designsystem-ui-react64.js";
function l({ padding: t = "responsive", className: e, children: s }) {
  const { direction: r } = a(p), o = {
    small: "p-3",
    medium: "p-4",
    large: "p-5",
    responsive: "p-4 @sm:p-5"
  }, n = {
    horizontal: "justify-center",
    responsive: "justify-start @md:justify-center",
    vertical: "justify-start"
    // 'responsive-reverse': 'justify-center @md:justify-start', // commented out, not in use
  }[r];
  return /* @__PURE__ */ i("div", { className: m("flex flex-col gap-2 flex-1", o[t], n, e), children: s });
}
l.displayName = "CardContent";
export {
  l as CardContent
};
